import React, { Component } from "react";
import { connect } from "react-redux";
import SearchIcon from '@material-ui/icons/Search';
class Button extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  
  render() {
      const {
        className,
        id,
        onButtonClick,
        buttonLabel,
        disableButton
      } = this.props;
    return (
      <React.Fragment>
          <button
                    class={className}
                    id={id}
                    onClick={onButtonClick}
                    disabled={disableButton}
                  >
                    {buttonLabel}{"  "}{buttonLabel==="Search" && <SearchIcon/>}
                  </button>
                 
      </React.Fragment>
    );
  }
}

export default Button;
